module.exports = __webpack_public_path__ + "media/season_summer.dc5060d4.mp3";